
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.402 3.2h243.2c1.77 0 3.199 1.433 3.199 3.198v179.204c0 1.765-1.43 3.199-3.2 3.199H6.403c-1.77 0-3.199-1.434-3.199-3.2V6.399c0-1.765 1.43-3.199 3.2-3.199zm0 0","fill":"none","stroke-width":"6.4","stroke":"#000"}}),_c('path',{attrs:{"d":"M24.004 149.148v-30.296A2.85 2.85 0 0126.852 116H50.52a2.852 2.852 0 012.851 2.852v30.296A2.852 2.852 0 0150.52 152H26.852a2.85 2.85 0 01-2.848-2.852zm0 0M60.71 149.148V79.25a2.852 2.852 0 012.852-2.852H87.23a2.852 2.852 0 012.852 2.852v69.898A2.852 2.852 0 0187.23 152H63.562a2.852 2.852 0 01-2.851-2.852zm0 0M97.422 149.148V97.25a2.852 2.852 0 012.851-2.852h23.668a2.852 2.852 0 012.852 2.852v51.898a2.852 2.852 0 01-2.852 2.852h-23.668a2.852 2.852 0 01-2.851-2.852zm0 0M134.133 149.148V46.852A2.852 2.852 0 01136.984 44h23.668a2.85 2.85 0 012.848 2.852v102.296a2.85 2.85 0 01-2.848 2.852h-23.668a2.852 2.852 0 01-2.851-2.852zm0 0","fill":"#e0e2e6"}}),_c('path',{attrs:{"d":"M192.504 66.5h35c1.101 0 2 .895 2 2v5.75c0 1.105-.899 2-2 2h-35c-1.106 0-2-.895-2-2V68.5c0-1.105.894-2 2-2zm0 0M192.504 85.25h35c1.101 0 2 .895 2 2V93c0 1.105-.899 2-2 2h-35c-1.106 0-2-.895-2-2v-5.75c0-1.105.894-2 2-2zm0 0M192.504 104h35c1.101 0 2 .895 2 2v5.75c0 1.102-.899 2-2 2h-35c-1.106 0-2-.898-2-2V106c0-1.105.894-2 2-2zm0 0M192.504 122.746h35c1.101 0 2 .899 2 2v5.75c0 1.106-.899 2-2 2h-35c-1.106 0-2-.894-2-2v-5.75c0-1.101.894-2 2-2zm0 0"}})])
          )
        }
      }
    